import {makeVar} from '@apollo/client'

const INITIAL_FLASH_VAR = {}

const flashTimeoutVar = makeVar(null)
export const flashVar = makeVar(INITIAL_FLASH_VAR)
export const flashStackVar = makeVar([])

export const setFlash = (message, {type = 'notice'} = {}) => {
  const currentTimeout = flashTimeoutVar()
  if (currentTimeout) clearTimeout(currentTimeout)

  flashVar({message, type})

  const newTimeout = setTimeout(() => {
    flashVar(INITIAL_FLASH_VAR)
    flashTimeoutVar(null)
  }, 3500)

  flashTimeoutVar(newTimeout)
}
